<template>
    <div class="home">
        <div id="pano" ref="pano"></div>

        <!-- <b-button class="nuSkinBtn goBackBtn" @click='onClickHome'
            ><span class="mdi mdi-arrow-left"></span>
            뉴스킨 HOME
        </b-button>
        <b-button class="nuSkinBtn goPromotion" @click='showTraningModal = !showTraningModal'
            ><span class="mdi mdi-arrow-left"></span>
            Modal
        </b-button> -->
        <b-button-group
            class="nuSkinBtnWrap toggleGyro"
            v-show="gyroIsAvailable"
        >
            <b-button
                class="nuSkinBtn nuSkinLightBtn toggleGyro"
                :class="{ active: isActiveGyro, deactive: !isActiveGyro }"
                @click="onClickToggleGyro"
                ><span class="mdi mdi-rotate-orbit"></span>화면 자동이동
            </b-button>
        </b-button-group>
        <b-button v-b-toggle.sidebar-main class="nuSkinBtn menuBtn"
            ><span class="mdi mdi-menu"></span
            ><span class="d-none d-md-inline-block" style="margin-left: 0.5em"
                >메뉴</span
            >
        </b-button>
        <div>
            <b-sidebar
                id="sidebar-main"
                v-model="sidebar.main"
                aria-labelledby="sidebar-main-title"
                title="뉴스킨 VR 라이브 센터"
                right
                shadow
            >
                <template #default="{ hide }">
                    <div class="p-3">
                        <p>뉴스킨 라이브 센터를 VR로 만나보세요.</p>
                        <nav class="mb-3">
                            <b-nav vertical>
                                <b-nav-item @click="onClickSideMenu('center')"
                                    >센터 소개</b-nav-item
                                >
                                <b-nav-item @click="onClickSideMenu('service')"
                                    >서비스 존 바로가기</b-nav-item
                                >
                            </b-nav>
                        </nav>
                    </div>
                </template>
            </b-sidebar>
            <b-sidebar
                id="sidebar-center"
                aria-labelledby="sidebar-center-title"
                title="VR 라이브 센터 소개"
                v-model="sidebar.center"
                right
                shadow
            >
                <template #default="{ hide }">
                    <b-img
                        :src="nuri_0195"
                        fluid-grow
                        alt="Fluid-grow image"
                    ></b-img>
                    <div style="background-color: #8257b6; color: #fff">
                        <p style="padding: 1em">
                            <strong style="font-size: 1.1em"
                                >VR 라이브 센터</strong
                            >
                        </p>
                    </div>
                    <div class="p-3">
                        <p>
                            당신이 찾던 모든 뉴스킨의 경험!<br />
                            <br />
                            VR 라이브 센터는<br />
                            비즈니스, 쇼핑, 브랜드 체험<br />
                            모든 것이 언택트로 가능한<br />
                            뉴스킨 코리아 최초의 가상 매장입니다.<br />
                        </p>
                    </div>
                    <hr />
                    <div class="p-3">
                        <b-row>
                            <b-col cols="4">전화번호</b-col>
                            <b-col cols="8"
                                ><a href="tel:1588-1440">1588-1440</a></b-col
                            >
                        </b-row>
                        <b-row>
                            <b-col cols="4">홈페이지</b-col>
                            <b-col cols="8"
                                ><a
                                    href="https://www.nuskinkorea.co.kr/app/"
                                    target="_blank"
                                    style="overflow-wrap: break-word"
                                    >www.nuskinkorea.co.kr</a
                                ></b-col
                            >
                        </b-row>
                    </div>
                </template>
            </b-sidebar>
            <b-sidebar
                id="sidebar-servicce"
                aria-labelledby="sidebar-servicce-title"
                title="서비스 존 바로가기"
                v-model="sidebar.service"
                right
                shadow
            >
                <template #default="{ hide }">
                    <div class="p-3">
                        <p>서비스 존 바로가기입니다.</p>
                    </div>
                    <b-list-group>
                        <b-list-group-item
                            button
                            v-for="(service, serviceIdx) in services"
                            :key="serviceIdx"
                            @click="onClickService(service)"
                            >{{ service.id }}.
                            {{ service.title }}</b-list-group-item
                        >
                    </b-list-group>
                </template>
            </b-sidebar>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

import { mapState, mapActions } from "vuex";

import FullCalendar from "@fullcalendar/vue";
import timeGridPlugin from "@fullcalendar/timegrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
// import bootstrapPlugin from '@fullcalendar/bootstrap';

// import 'bootstrap/dist/css/bootstrap.css';
// import '@fortawesome/fontawesome-free/css/all.css';

import nuri_0195 from "@/assets/img/nuri_0195.jpg";
// import Events from '@/assets/data/events'
import Services from "@/assets/data/services";

export default {
    name: "Home",
    components: {
        FullCalendar,
    },
    data() {
        return {
            isMobile: false,
            krpano: null,
            gyroIsAvailable: false,
            isActiveGyro: false,
            sidebar: {
                main: false,
                center: false,
                service: false,
            },
            nuri_0195:
                process.env.NODE_ENV === "production"
                    ? process.env.VUE_APP_PRODUCTION_CDN + "/img/nuri_0195.jpg"
                    : nuri_0195,
            services: Services,
            eventFilter: {
                area: [
                    { title: "서울", state: false },
                    { title: "부천", state: false },
                    { title: "대구경북", state: false },
                    { title: "광주", state: false },
                    { title: "부산", state: false },
                    { title: "본사", state: false },
                ],
                title: "",
            },
            traningData: null,
        };
    },
    created() {},
    mounted() {
        window.addEventListener("resize", this.onResize);
        this.onResize();

        let swfPath =
            process.env.NODE_ENV === "production"
                ? process.env.VUE_APP_PRODUCTION_CDN + "/assets/vtour/tour.swf"
                : "assets/vtour/tour.swf";
        let xmlPath =
            process.env.NODE_ENV === "production"
                ? process.env.VUE_APP_PRODUCTION_CDN + "/assets/vtour/tour_pc.xml"
                : "assets/vtour/tour_pc.xml";
        embedpano({
            swf: swfPath,
            xml: xmlPath,
            target: "pano",
            id: "vr",
            html5: "auto",
            mobilescale: 1.0,
            initvars: { editor: 0 },
            passQueryParameters: true,
            onready: this.onReadyKrpano,
        });
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    computed: {
        convertedEvents() {
            if (!this.NUSKIN_EVENTS || !this.NUSKIN_EVENTS_202101) {
                return [];
            }
            let eventIdx = 0;
            this.NUSKIN_EVENTS = [
                ...this.NUSKIN_EVENTS,
                ...this.NUSKIN_EVENTS_202101,
            ];
            this.NUSKIN_EVENTS.forEach((event) => {
                event.title = `[${event.area}]${event.subject}`;
                event.idx = eventIdx;
                eventIdx += 1;
            });
            return this.NUSKIN_EVENTS;
        },
        filteredEvents() {
            let areaFilter = this.eventFilter.area.filter((area) => area.state);
            if (this.eventFilter.title.length || areaFilter.length) {
                return this.convertedEvents.filter((event) => {
                    if (areaFilter.length) {
                        for (let i in areaFilter) {
                            if (areaFilter[i].title == event.area) {
                                return true;
                            }
                        }
                    }
                    if (this.eventFilter.title.length) {
                        if (event.title.indexOf(this.eventFilter.title) != -1) {
                            return true;
                        }
                    }
                });
            }
            return this.convertedEvents;
        },
    },
    methods: {
        onResize(event) {
            this.isMobile = window.innerWidth <= 768 ? true : false;
        },
        onReadyKrpano(krpano) {
            this.krpano = krpano;
        },
        // main.xml 의 onnewpano에서 실행.
        onKrpanoStartup() {
            // 쿼리로 로딩 파노 설정
            if (this.$route.query.startScene) {
                    console.info('this.$route.query.startScene', this.$route.query.startScene);

                this.krpano.call(`loadscene(${this.$route.query.startScene})`);
            }
            this.krpano.call('start_bgm()');
        },
        onKrpanoGyroOn() {
            this.gyroIsAvailable = this.krpano.get(
                "plugin[skin_gyro].isavailable"
            );
            if (this.krpano.get("plugin[skin_gyro].enabled")) {
                this.isActiveGyro = true;
            } else {
                this.isActiveGyro = false;
            }
        },
        // main.xml 의 onnewpano에서 실행.
        checkCurrentPano() {
            this.setCurrentScene(this.krpano.get("xml.scene"));
        },
        loadLocalStoragedItem(itemKey) {
            this.isLocalStorageAvailable = this.$localStorage.available(
                "localStorage"
            );
            if (this.isLocalStorageAvailable) {
                return this.$localStorage.getData(itemKey);
            } else {
                console.error(
                    "localstorage 가 불가능합니다. 일부 기능이 정상작동 하지 않습니다."
                );
            }
            return null;
        },
        onClickSideMenu(type) {
            this.sidebar.main = false;

            if (type == "center") {
                this.sidebar.service = false;
                this.sidebar.center = true;
            } else if (type == "service") {
                this.sidebar.center = false;
                this.sidebar.service = true;
            } else {
                console.error("onClickSideMenu unexpected type", type);
            }
        },
        onClickService(service) {
            if (service.scene == "scene_1" && service.lookat) {
                this.krpano.set(`scene[${service.scene}].freeze`, true);
                setTimeout(() => {
                    this.krpano.set(`scene[${service.scene}].freeze`, false);
                }, 1000);
            }

            this.krpano.call(`loadscene(${service.scene})`);
            if (service.lookat) {
                this.krpano.call(`lookat(${service.lookat})`);
            }
        },
        onClickToggleGyro() {
            if (this.krpano.get("plugin[skin_gyro].enabled")) {
                this.krpano.set("plugin[skin_gyro].enabled", false);
                this.krpano.set("plugin[skin_gyro].usersetdisabled", true);
                this.isActiveGyro = false;
            } else {
                this.krpano.set("plugin[skin_gyro].enabled", true);
                this.krpano.set("plugin[skin_gyro].usersetdisabled", false);
                this.isActiveGyro = true;
            }
        },
        onClickLinkBranch(param1, param2) {
            linkBranch(param1, param2);
        },
        
        onClickOpenUrl(url) {
            window.open(url);
        },
    },
};
</script>

<style scoped>
.home,
#pano {
    width: 100%;
    height: 100%;
}
.home {
    position: relative;
}

.only-pc {
    display: none;
}
@media screen and (min-width: 960px) {
    .only-pc {
        display: block;
    }
}

.nuSkinBtn,
.nuSkinBtn:focus,
.nuSkinBtn:active {
    background-color: #651fbb;
    position: absolute;
}
.nuSkinBtn:hover {
    background-color: #440099 !important;
    border-color: #440099 !important;
}
.nuSkinBtn.nuSkinLightBtn,
.nuSkinBtn.nuSkinLightBtn:focus,
.nuSkinBtn.nuSkinLightBtn:active {
    background-color: #8257b6;
    position: absolute;
}
.nuSkinBtn.nuSkinLightBtn:hover {
    background-color: #651fbb !important;
    border-color: #651fbb !important;
}
.nuSkinBtnWrap {
    position: absolute;
}
.nuSkinBtnWrap.toggleGyro {
    top: 4em;
    /* top: 10em; */
    right: 1em;
}
.nuSkinBtnWrap.toggleGyro > .nuSkinBtn,
.nuSkinBtnWrap.toggleGyro > .nuSkinBtn:hover {
    position: initial;
    background-color: #8257b6;
}
.nuSkinBtnWrap.toggleGyro > .nuSkinBtn.active {
    background-color: #440099;
}
.nuSkinBtnWrap.toggleGyro > .nuSkinBtn.deactive {
    background-color: #6b6b6b !important;
}

.nuSkinBtn > .mdi {
    margin-right: 0.5em;
}
.nuSkinBtn > .mdi.mdi-menu {
    margin-right: 0;
}
.goPromotion {
    top: 7em;
    left: 1em;
}
.goBackBtn {
    top: 1em;
    left: 1em;
}
.goMall {
    top: 4em;
    left: 1em;
}
.menuBtn {
    top: 1em;
    right: 1em;
}
#modal-xl___BV_modal_outer_ >>> a {
    color: #000 !important;
}
#modal-xl___BV_modal_outer_ >>> .modal-xl {
    max-width: 95%;
}
#modal-xl___BV_modal_outer_ >>> .fc-header-toolbar {
    display: block;
}
@media screen and (min-width: 960px) {
    #modal-xl___BV_modal_outer_ >>> .fc-header-toolbar {
        display: inherit;
    }
}
</style>